import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MovieContext } from "../app-context/MovieContext";
import SearchBar from "../components/Search";
import MovieCard from "../components/movie/Card";
import Layout from "../components/Layout";

const Home = () => {
  const { movies, loading, error } = useContext(MovieContext);
  const navigate = useNavigate();

  useEffect(() => {
    const email = localStorage.getItem("email");
    if (!email) {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <Layout>
      <div className="container mx-auto">
        <h1 className="text-2xl text-center my-4">Add Movies to Watchlists</h1>
        <SearchBar />
        {loading && <p>Loading...</p>}
        {error && <p>Error: {error}</p>}
        <div className="grid grid-cols-4 gap-4">
          {movies &&
            movies.map((movie) => (
              <MovieCard key={movie.imdbID} movie={movie} />
            ))}
        </div>
      </div>
    </Layout>
  );
};

export default Home;
